import { render, staticRenderFns } from "./SetClass.vue?vue&type=template&id=70693022&scoped=true"
import script from "./SetClass.vue?vue&type=script&lang=js"
export * from "./SetClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70693022",
  null
  
)

export default component.exports